
import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import HomePlan from "./HomePlan";

export default function UpdatePlane() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="Package Benefits" parent="Home" title="Package Benefits" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                       <HomePlan/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
